import { RecordType } from '@petconsole/pure-base';
import { Api } from '@petconsole/pure-shared';

const payloadCreatorDeleteEntity =
  <T extends RecordType = RecordType>(_sliceName: string, idName: string, api: Api<T>) =>
  async ({ [idName]: id }: T) =>
    api.delete(id as string);

export default payloadCreatorDeleteEntity;
